import { useAtomValue } from 'jotai'
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/interactives/Tooltip.jsx'

import { cn } from '@/utils'

import { pingAtom } from '@/store/runner.store.js'

enum ConnectionStates {
  OFFLINE = -1,
  GOOD = 3,
  MEDIOCRE = 2,
  WARNING = 1,
  SLOW = 0,
}

function getStatus(ping: number) {
  if (ping <= 0) return ConnectionStates.OFFLINE
  if (ping < 350) return ConnectionStates.GOOD
  if (ping < 700) return ConnectionStates.MEDIOCRE
  if (ping < 1200) return ConnectionStates.WARNING
  return ConnectionStates.SLOW
}

export function RundownNavbarConnectionStatus() {
  const ping = useAtomValue(pingAtom)

  const status = getStatus(ping)

  const statusColor = {
    [ConnectionStates.OFFLINE]: 'text-white',
    [ConnectionStates.SLOW]: 'text-red-400',
    [ConnectionStates.WARNING]: 'text-amber-400',
    [ConnectionStates.MEDIOCRE]: 'text-lime-400',
    [ConnectionStates.GOOD]: 'text-green-400',
  }[status]

  return (
    <Tooltip>
      <TooltipTrigger>
        <div className={cn('flex items-baseline gap-1 pt-1', statusColor)}>
          <div
            className={cn(
              'w-1 h-2 rounded-sm bg-current',
              status < 1 ? 'opacity-50' : '',
            )}
          ></div>
          <div
            className={cn(
              'w-1 h-3 rounded-sm bg-current',
              status < 2 ? 'opacity-50' : '',
            )}
          ></div>
          <div
            className={cn(
              'w-1 h-4 rounded-sm bg-current',
              status < 3 ? 'opacity-50' : '',
            )}
          ></div>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        Connection ping: {ping > 0 ? ping : 'Offline'}
      </TooltipContent>
    </Tooltip>
  )
}
